import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { ProfileDTO, ProfileSlice } from '@/models'
import { useAppDispatch } from '@/store/store'

import { getProfile } from '../selectors'
import { requestProfile } from '../slice'

export const useProfile = () => {
    const dispatch = useAppDispatch()
    const profile = useSelector(getProfile)

    const [isLoading, setIsLoading] = useState(false)

    const fetchProfile = useCallback(async () => {
        setIsLoading(true)
        try {
            const profileResponse = await dispatch(requestProfile()).unwrap()

            return profileResponse
        } finally {
            setIsLoading(false)
        }
    }, [dispatch])

    return { profile, fetchProfile, isLoading } as {
        profile: ProfileSlice
        fetchProfile: () => Promise<ProfileDTO>
        isLoading: boolean
    }
}
